import React, { useMemo, useState } from "react";
import { firebaseAuth, firestore } from "../../firebase/firebaseConfig";

const AddUnit = () => {
  const unitsRef = firestore.collection('units');
  const factionsRef = firestore.collection('factions');

  const [rawJsonData, setRawJsonData] = useState({});

  const jsonData = useMemo(() => {
    try {
        const data = JSON.parse(rawJsonData);
        console.log(data);
        return data;
    } catch (error) {
        console.log(error);
        return {};
    }
  }, [rawJsonData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const {datasheets, link, ...rest} = jsonData;
    if (!datasheets) {
      alert('Malformed text');
      return;
    }
    const {uid} = firebaseAuth.currentUser;
    factionsRef.doc(rest.id).set({...rest, lastUpdatedBy: uid})
    const batch = firestore.batch();
    for (let i = 0; i < datasheets.length; i++) {
      const {id, ...unit} = datasheets[i];
      batch.set(unitsRef.doc(id), unit);
    }
    batch.commit();
    alert('updated units for ' + rest.id)
  };

  return (
    <form onSubmit={handleSubmit}>
      <textarea
        value={rawJsonData}
        onChange={(e) => {setRawJsonData(e.target.value)}}
      />
      <div>
        Add or update content by pasting one of these files for the faction of your choice: <a href="https://github.com/game-datacards/datasources/tree/main/10th/gdc">click here</a>
      </div>
      {
        jsonData && (
          <div>
            <h1>{jsonData.name}</h1>
            <h2>Add/update {jsonData?.datasheets?.length} datasheets</h2>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
              <div
                style={{
                  width: 30,
                  height: 30,
                  backgroundColor: jsonData?.colours?.banner ?? '#fff'
                }}
              />
              <div
                style={{
                  width: 30,
                  height: 30,
                  backgroundColor: jsonData?.colours?.header ?? '#fff'
                }}
              />
            </div>
          </div>
        )
      }
      <button type="submit" disabled={!jsonData.datasheets}>Submit</button>
    </form>
  );
};

export default AddUnit;
